var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.476318,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F4F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.373 16.1968C14.5585 16.3836 14.8024 16.4763 15.0463 16.4763C15.289 16.4763 15.5342 16.3836 15.7197 16.1968C16.092 15.8246 16.092 15.2223 15.7197 14.8501L13.3461 12.4759L15.7171 10.1049C16.0893 9.73267 16.0893 9.13045 15.7171 8.7582C15.3448 8.38594 14.7426 8.38594 14.3703 8.7582L11.9995 11.1291L9.62641 8.75551C9.25542 8.38325 8.65321 8.38325 8.27968 8.75551C7.90742 9.12777 7.90742 9.72998 8.27968 10.1022L10.6527 12.4758L8.28212 14.8464C7.90987 15.2187 7.90987 15.8209 8.28212 16.1931C8.46761 16.3799 8.71155 16.4727 8.95548 16.4727C9.19942 16.4727 9.44336 16.3799 9.62885 16.1931L11.9993 13.8227L14.373 16.1968Z",
    fill: "#AAB4C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.20604abba0cdfefb39edbbf2bb411fc3.svg";
export { ForwardRef as ReactComponent };